import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import { Image02Icon } from "@hugeicons/core-free-icons";
import PageTitle from '../../../jsx/layouts/PageTitle';
import ConfirmModal from "./ConfirmModal";
import { updateEditProfileById, submitEditProfileDecision } from "../../../services/adminApiService/editProfileApi/editProfileApis";
import { toast } from 'react-toastify';

const EditProfileRequestView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [previousUser, setPreviousUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [parsedMetaValue, setParsedMetaValue] = useState(null);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  useEffect(() => {
    const fetchDataById = async () => {
      try {
        setLoading(true);
        console.log("Fetching data for ID:", id);
        const response = await updateEditProfileById(id);
        const apiData = response.data.data;
        setData(apiData);

        // Parse meta_value
        if (apiData.meta_value) {
          try {
            const parsed = JSON.parse(apiData.meta_value);
            setParsedMetaValue(parsed);
          } catch (e) {
            console.error("Error parsing meta_value:", e);
          }
        }

        setPreviousUser(apiData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching data by ID:", error);
        setLoading(false);
      }
    };
    fetchDataById();
  }, [id]);

  const getDocumentUrl = (docFile) => {
    if (!docFile) return null;
    const rawBase = process.env.REACT_APP_UPLOADED_DOC_URL || '';
    const base = rawBase.replace(/\/+$/, '');
    const path = String(docFile).replace(/^\/+/, '');
    return base ? `${base}/${path}` : `/${path}`;
  };

  const getDocumentDetails = (documentKey) => {
    if (!documentKey || !data?.document_details) return null;
    return data.document_details[documentKey];
  };

  const renderProfileImageSection = () => {
    if (!parsedMetaValue?.profile_image) return null;
    
    const documentDetails = getDocumentDetails('profile_image');
    
    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>Profile Image</h6>
        
        <Row className="g-3">
          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>Upload Supportive Document <span className="text-danger">*</span></label>
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  <img
                    src={getDocumentUrl(documentDetails.doc_file)}
                    alt="document"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>
              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View
                </a>
              )}
              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
            
          </Col>
        </Row>
      </div>
    );
  };

  const renderNameSection = () => {
    if (!parsedMetaValue?.name) return null;
    
    const { first_name, middle_name, last_name } = parsedMetaValue.name;
    const documentDetails = getDocumentDetails('name_image');
    
    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>Name</h6>
        
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>First Name</label>
            <input
              type="text"
              className="form-control "
              value={first_name || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Middle Name</label>
            <input
              type="text"
              className="form-control "
              value={middle_name || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Last Name</label>
            <input
              type="text"
              className="form-control"
              value={last_name || ''}
              readOnly
              disabled
            />
          </Col>

          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>Upload Supportive Document <span className="text-danger">*</span></label>
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  <img
                    src={getDocumentUrl(documentDetails.doc_file)}
                    alt="document"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>
              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View
                </a>
              )}
              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
            
          </Col>
        </Row>
      </div>
    );
  };

  const renderAddressSection = () => {
    if (!parsedMetaValue?.address) return null;
    
    const { district, pincode, landmark } = parsedMetaValue.address;
    const documentDetails = getDocumentDetails('address_image');
    
    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>Address</h6>
        
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>District</label>
            <input
              type="text"
              className="form-control "
              value={district || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Pincode</label>
            <input
              type="text"
              className="form-control "
              value={pincode || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Landmark</label>
            <input
              type="text"
              className="form-control"
              value={landmark || ''}
              readOnly
              disabled
            />
          </Col>

          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>Upload Supportive Document <span className="text-danger">*</span></label>
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  <img
                    src={getDocumentUrl(documentDetails.doc_file)}
                    alt="document"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>
              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View
                </a>
              )}
              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
            
          </Col>
        </Row>
      </div>
    );
  };

  const renderDOBSection = () => {
    if (!parsedMetaValue?.date_of_birth) return null;
    
    const { dob } = parsedMetaValue.date_of_birth;
    const documentDetails = getDocumentDetails('dob_image');
    
    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>DOB</h6>
        
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Kit Size</label>
            <input
              type="text"
              className="form-control"
              value={dob || ''}
              readOnly
              disabled
            />
          </Col>

          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>Upload Supportive Document <span className="text-danger">*</span></label>
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  <img
                    src={getDocumentUrl(documentDetails.doc_file)}
                    alt="document"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>
              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View
                </a>
              )}
              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
            
          </Col>
        </Row>
      </div>
    );
  };

  const renderKitSizeSection = () => {
    if (!parsedMetaValue?.kit_size) return null;
    
    const { kit_size } = parsedMetaValue.kit_size;
    const documentDetails = getDocumentDetails('kit_size_image');
    
    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>Kit Size</h6>
        
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Kit Size</label>
            <input
              type="text"
              className="form-control "
              value={kit_size || ''}
              readOnly
              disabled
            />
          </Col>

          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>Upload Supportive Document <span className="text-danger">*</span></label>
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  <img
                    src={getDocumentUrl(documentDetails.doc_file)}
                    alt="document"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>
              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View
                </a>
              )}
              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
            
          </Col>
        </Row>
      </div>
    );
  };

  const renderShoeSizeSection = () => {
    if (!parsedMetaValue?.shoe_size) return null;
    
    const { shoe_size } = parsedMetaValue.shoe_size;
    const documentDetails = getDocumentDetails('shoe_size_image');
    
    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>Shoe Size</h6>
        
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Shoe Size</label>
            <input
              type="text"
              className="form-control"
              value={shoe_size || ''}
              readOnly
              disabled
            />
          </Col>

          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>Upload Supportive Document <span className="text-danger">*</span></label>
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  <img
                    src={getDocumentUrl(documentDetails.doc_file)}
                    alt="document"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>
              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View
                </a>
              )}
              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
            
          </Col>
        </Row>
      </div>
    );
  };

  const renderBankDetailsSection = () => {
    if (!parsedMetaValue?.bank_details) return null;
    
    const { 
      bank_name, 
      account_holder_name, 
      bank_account_number, 
      branch_name, 
      ifsc_code 
    } = parsedMetaValue.bank_details;
    const documentDetails = getDocumentDetails('cancelled_cheque_or_passbook');
    

    return (
      <div className="border rounded mb-4 p-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#FFFFFF' }}>
        <h6 className="mb-3" style={{ color: '#6366F1', fontWeight: 600 }}>Bank Details</h6>
        
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Bank Name</label>
            <input
              type="text"
              className="form-control "
              value={bank_name || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Account Holder Name</label>
            <input
              type="text"
              className="form-control"
              value={account_holder_name || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Account Number</label>
            <input
              type="text"
              className="form-control"
              value={bank_account_number || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>Branch Name</label>
            <input
              type="text"
              className="form-control"
              value={branch_name || ''}
              readOnly
              disabled
            />
          </Col>
          <Col md={4}>
            <label className="form-label" style={{ fontWeight: 500 }}>IFSC Code</label>
            <input
              type="text"
              className="form-control "
              value={ifsc_code || ''}
              readOnly
              disabled
            />
          </Col>

          <Col xs={12}>
            <label className="form-label" style={{ fontWeight: 500 }}>
              Upload Cancelled Cheque/Passbook{" "}
              <span className="text-danger">*</span>
            </label>

            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  background: "#F9FAFB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {documentDetails ? (
                  (() => {
                    const fileUrl = getDocumentUrl(documentDetails.doc_file);
                   
                    const isPdf =
                      fileUrl?.toLowerCase()?.includes(".pdf");

                    return isPdf ? (
                      // <img
                      //   src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                      //   alt="pdf"
                      //   style={{
                      //     width: "40px",
                      //     height: "40px",
                      //     objectFit: "contain",
                      //   }}
                      <h1>pdf</h1>
                      
                    ) : (
                      <img
                        src={fileUrl}
                        alt="document"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    );
                  })()
                ) : (
                  <HugeiconsIcon icon={Image02Icon} className="text-muted" />
                )}
              </div>

              {documentDetails && (
                <a
                  href={getDocumentUrl(documentDetails.doc_file)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  View File
                </a>
              )}

              <span className="text-muted small">
                {documentDetails ? "Selected File" : "No File Chosen"}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const getStatusBadge = () => {
    const status = data?.status?.toLowerCase() || "pending";
    let bgColor = "#FEF3C7";
    let textColor = "#F59E0B";
    let icon = "bi-clock-history";

    if (status === "approved") {
      bgColor = "#D1FAE5";
      textColor = "#10B981";
      icon = "bi-check-circle-fill";
    } else if (status === "reject" || status === "rejected") {
      bgColor = "#FEE2E2";
      textColor = "#EF4444";
      icon = "bi-x-circle-fill";
    }

    return (
      <div className="d-flex align-items-center gap-2 mb-3">
        <i className={`bi ${icon}`} style={{ color: textColor, fontSize: '20px' }}></i>
        <span
          style={{
            backgroundColor: bgColor,
            color: textColor,
            padding: "6px 16px",
            borderRadius: "16px",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "capitalize"
          }}
        >
          {data?.status || "Pending"}
        </span>
      </div>
    );
  };


  if (loading || !previousUser) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <>
      <PageTitle activeMenu="Edit Profile Request List View" motherMenu="Edit Profile Request" />
      <div className="container py-4" style={{ background: '#FFFFFF', minHeight: '100vh', minWidth: '100%', borderRadius: 8 }}>
        <h3 className="text-primary mb-4">Edit Profile Request List</h3>


          {getStatusBadge()}
           
            
            {/* Comment if rejected or approved */}
            {data.comment && (
              <div className={`alert ${data?.status === 'approved' ? 'alert-success' : 'alert-danger'} mb-3`} role="alert">
                <strong>{data?.status === 'rejected' ? 'Reason:' : ''}</strong> {data?.comment}
              </div>
            )}

        
        {/* Previous User Details */}
        <div className="border rounded mb-4 p-3 position-relative" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <span className="btn btn-outline-dark position-absolute end-0 mt-2 me-3"
            style={{ color: '#2D3747', borderRadius: 18, padding: '6px 16px', fontWeight: 500, fontSize: 14 }}
          >
            Previous
          </span>
          <h6 className="fs-4 mb-3">Previous User Details</h6>
          <div className="align-items-center mb-3">
            <div className="col-auto text-center">
              <div className="border d-inline-block mb-2 rounded" style={{ backgroundColor: "#EEEEEE", width: 80, height: 80, overflow: 'hidden' }}>
                {previousUser.profile_image ? (
                  <img
                    src={getDocumentUrl(previousUser.profile_image)}
                    alt="Profile"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="bi bi-person-circle" style={{ fontSize: 32, color: '#9CA3AF' }}></i>
                  </div>
                )}
              </div>
              <div className="text-center">
                <span style={{ background: '#F4EEFD', color: '#753FC9', borderRadius: 16, padding: '4px 16px', fontWeight: 500, fontSize: 14, display: 'inline-block' }}>
                  Atom ID: {previousUser.atom_id}
                </span>
              </div>
            </div>
            <div className="col">
              <div className="row g-3">
                <div className="col-md-4"><div className="heading">Full Name</div><div>{previousUser.first_name}</div></div>
                <div className="col-md-4"><div className="heading">Gender</div><div>{previousUser.gender}</div></div>
                <div className="col-md-4"><div className="heading">Email ID</div><div>{previousUser.email}</div></div>
                <div className="col-md-4"><div className="heading">Mobile Number</div><div>{previousUser.mobile}</div></div>
                <div className="col-md-4"><div className="heading">Identification</div><div>{previousUser.identity_type}</div></div>
                <div className="col-md-4">
                  <div className="heading">Identification Document</div>
                  {previousUser.identity_type_url ? (
                    <a
                      href={getDocumentUrl(previousUser.identity_type_url)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline"
                    >
                      {previousUser.identity_type}
                    </a>
                  ) : (
                    <span className="text-muted">No document</span>
                  )}
                </div>
                <div className="col-md-4"><div className="heading">Landmark</div><div>{previousUser.landmark}</div></div>
                <div className="col-md-4"><div className="heading">Country</div><div>India</div></div>
                <div className="col-md-4"><div className="heading">State</div><div>{previousUser.state_name}</div></div>
                <div className="col-md-4"><div className="heading">City</div><div>{previousUser.city_name}</div></div>
                <div className="col-md-4"><div className="heading">Pincode</div><div>{previousUser.pincode}</div></div>
                <div className="col-md-4"><div className="heading">DOB</div><div>{previousUser.dob}</div></div>
              </div>
              <div className="mt-3"><div className="heading">Full Address</div><div>{previousUser.address}</div></div>
            </div>
          </div>
        </div>

        {/* Updated User Details */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fs-4" style={{ color: "#000413" }}>Updated User Details</h6>
            <span className="badge" style={{ color: '#4AA564', borderRadius: 18, padding: '6px 16px', fontWeight: 500, fontSize: 14, border: '1px solid #4AA564' }}>
              Updated
            </span>
          </div>

          {/* Render all sections */}
          {renderProfileImageSection()}
          {renderNameSection()}
          {renderAddressSection()}
          {renderDOBSection()}
          {renderKitSizeSection()}
          {renderShoeSizeSection()}
          {renderBankDetailsSection()}


 <div className="mt-4">
            {data?.status === "pending" ? (
              <div className="d-flex gap-2">
                <button
                  className="btn flex-fill py-2"
                  style={{ fontSize: 18, backgroundColor: '#C62828', color: "#F9FAFB" }}
                  onClick={() => setShowRejectModal(true)}
                >
                  Reject
                </button>
                <button
                  className="btn flex-fill py-2"
                  style={{ fontSize: 18, backgroundColor: '#4AA564', color: "#F9FAFB" }}
                  onClick={() => setShowApproveModal(true)}
                >
                  Approve
                </button>
              </div>
            ) : (
              
              ""
            )}
          </div>

        </div>
      </div>

      {/* Modals */}
      <ConfirmModal
        type="approve"
        show={showApproveModal}
        handleClose={() => setShowApproveModal(false)}
        onConfirm={async (remark) => {
          try {
            await submitEditProfileDecision(id, "approved");
            toast.success("Profile edit request approved successfully");
            setShowApproveModal(false);
            navigate(-1);
          } catch (error) {
            console.error("Error approving request:", error);
            toast.error("Failed to approve profile edit request");
          }
        }}
      />

      <ConfirmModal
        type="reject"
        show={showRejectModal}
        handleClose={() => setShowRejectModal(false)}
        onConfirm={async (remark) => {
          try {
            await submitEditProfileDecision(id, "rejected", remark);
            toast.success("Profile edit request rejected successfully");
            setShowRejectModal(false);
            navigate(-1);
          } catch (error) {
            console.error("Error rejecting request:", error);
            toast.error("Failed to reject profile edit request");
          }
        }}
      />
    </>
  );
};

export default EditProfileRequestView;